import type { Leerling } from '../types';
import { begroeting, klokDatum, klokTijd } from '../lib/tijd';
import { Logo } from './Logo';

interface Props {
  leerlingnummer: string;
  leerling: Leerling | null;
  tijd: Date;
}

export function Header({ leerlingnummer, leerling, tijd }: Props) {
  const klas = leerling ? [leerling.klas, leerling.niveau].filter(Boolean).join(' · ') : '';

  return (
    <header>
      <div className="brand">
        <Logo />
        <div className="brand-text">
          <div className="school">Pallas Athene College</div>
          <div className="tag">Leerlingrooster</div>
        </div>
      </div>

      {leerlingnummer && (
        <div className="student-pill">
          <span className="avatar" aria-hidden="true">{leerlingnummer.slice(-2)}</span>
          <span className="name">
            {begroeting(tijd)} {leerlingnummer}
          </span>
          {klas && <span className="klas">{klas}</span>}
        </div>
      )}

      <div className="clock-block">
        <div className="time">{klokTijd(tijd).slice(0, 5)}<small>{klokTijd(tijd).slice(5)}</small></div>
        <div className="date">
          {klokDatum(tijd)}
        </div>
      </div>
    </header>
  );
}
